function updateCheckbox( field, type ) {
  if ( type === 'label' ) {
    field.trigger('click');

  } else {
    var isExclusive = field.parents('.wpcf7-checkbox').hasClass('wpcf7-exclusive-checkbox'),
        fieldStatus = field.parents('.wpcf7-list-item').hasClass('checked');

    // Unselect all if Exclusive
    if ( isExclusive ) {
      field.parents('.wpcf7-checkbox').find('.checked').removeClass('checked');
    }

    // Unselect if already selected
    if ( fieldStatus ) {
      field.parents('.wpcf7-list-item').removeClass('checked');
    }
    
    // Select if currently unselected
    if ( !fieldStatus ) {
      field.parents('.wpcf7-list-item').addClass('checked');
    }
  }
}



function init() {

  // Update custom checkbox on checked
  if ( $('form.wpcf7-form input[type="checkbox"] + span.wpcf7-list-item-label').length > 0 ) {

    $('form.wpcf7-form input[type="checkbox"] + span.wpcf7-list-item-label').on('click', function() {
      var field = $(this).parents('.wpcf7-list-item').find('input[type="checkbox"]');

      updateCheckbox( field, 'label' );
    });

    $('form.wpcf7-form input[type="checkbox"]').on('click', function() {
      var field = $(this);

      updateCheckbox( field, 'input' );
    });
  }

}

module.exports = { init };